import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { recursiveDateFormatter } from '../../utils/date-formatter';

@Injectable()
export class RsDateFormatterInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.body instanceof Object && !(request.body instanceof FormData)) {
      const formattedBody = recursiveDateFormatter(request.body);

      const req = request.clone({
        body: formattedBody,
      });

      return next.handle(req);
    }

    return next.handle(request);
  }
}

